'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _photoswipe = require('photoswipe');

var _photoswipe2 = _interopRequireDefault(_photoswipe);

var _photoswipeUiDefault = require('photoswipe/dist/photoswipe-ui-default');

var _photoswipeUiDefault2 = _interopRequireDefault(_photoswipeUiDefault);

require('../../styles/components/photoswipe.scss');

require('../../styles/components/photoswipe-overrides.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var photoswipeEl = document.querySelector('[data-photoswipe]');

var ImageZoom = function () {
  function ImageZoom(images) {
    (0, _classCallCheck3.default)(this, ImageZoom);

    this.images = images;
    this.conductor = this.conductor.bind(this);
  }

  (0, _createClass3.default)(ImageZoom, [{
    key: 'open',
    value: function open(imageId, imageEl) {
      var _this = this;

      document.body.classList.add('scroll-locked');

      var index = 0;

      if (imageId != null) {
        for (var i = 0; i < this.images.length; i++) {
          if (this.images[i].id === imageId) {
            index = i;
            break;
          }
        }
      }

      var options = {
        arrowEl: true,
        barsSize: {
          top: 0,
          bottom: 'auto'
        },
        captionEl: true,
        clickToCloseNonZoomable: false,
        closeOnScroll: false,
        counterEl: false,
        fullscreenEl: false,
        getThumbBoundsFn: function getThumbBoundsFn() {
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;

          var rect = imageEl.getBoundingClientRect();

          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        },
        addCaptionHTMLFn: function addCaptionHTMLFn(item, captionEl, isFake) {
          if (!isFake) {
            if (item.html) {
              captionEl.children[0].innerHTML = '';
            } else {
              captionEl.children[0].innerHTML = '<span class="mobile--hide">Click image to zoom</span><span class="desktop--hide">Double tap image to zoom</span>';
            }
          }
        },
        index: index,
        shareEl: false,
        showHideOpacity: true,
        timeToIdle: false,
        timeToIdleOutside: false,
        zoomEl: false,
        history: false
      };

      this.photoswipe = new _photoswipe2.default(photoswipeEl, _photoswipeUiDefault2.default, this.images, options);

      this.photoswipe.listen('afterChange', function () {
        if (_this.photoswipe.currItem.html && ~_this.photoswipe.currItem.html.indexOf('model-viewer')) {
          _this.allowSwipe = false;
          _this.photoswipe.container.classList.add('model-view');
        } else {
          _this.allowSwipe = true;
          _this.photoswipe.container.classList.remove('model-view');
        }
      });

      this.photoswipe.listen('close', function () {
        _this.photoswipe.container.querySelectorAll('video').forEach(function (v) {
          return v.pause();
        });
        document.body.classList.remove('scroll-locked');
      });

      this.photoswipe.listen('afterChange', function () {
        _this.photoswipe.container.querySelectorAll('video').forEach(function (v) {
          return v.pause();
        });
        _this.photoswipe.currItem && _this.photoswipe.currItem.container.querySelectorAll('video').forEach(function (v) {
          return v.play();
        });
      });

      this.photoswipe.listen('zoomGestureStarted', function () {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'event': 'Image Zoom In' });
      });

      this.photoswipe.listen('doubleTap', function () {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'event': 'Image Zoom In' });
      });

      this.photoswipe.init();
    }
  }, {
    key: 'conductor',
    value: function conductor(e) {
      if (!this.allowSwipe) {
        e.stopPropagation();
      }
    }
  }, {
    key: 'close',
    value: function close() {
      if (this.photoswipe) {
        this.photoswipe.close();
      }
    }
  }, {
    key: 'unload',
    value: function unload() {
      this.close();
    }
  }]);
  return ImageZoom;
}();

exports.default = ImageZoom;